<template>
    <div class="form-group mr-b-0em">
        <div class="mb-2">
            <b class="form-label"> {{ props.TextLabel }} </b>
            <Multiselect :trackby="props.trackby" :valueProp="String(props.valueProp)" :label="props.label"
                v-model="selectedValue" :placeholder="`${$t(props.placeholder)}`" :options="props.arrayOptions"
                :multiple="true" mode="tags" :object="true" :close-on-select="false" :allow-empty="false"
                deselect-label="Can't remove this value" :ref="props.refs" :searchable="true" @input="handleSelect" />
            <!--  :clear-on-select="true" :preserve-search="false" :infinite="true" :limit="10" :clear-on-search="false"
                :delay="0" :filter-results="true" :min-chars="1" -->
            <span class="text-danger" v-for="error in $props.v?.$errors" :key="error.$uid">{{
                error.$message
                }}</span>
        </div>
    </div>

</template>

<script lang="ts">
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'
import { defineComponent, toRefs, ref, PropType, watch } from "vue";
export default defineComponent({
    components: { Multiselect },
    name: "MultipSelect",
    props: {
        modelValue: {
            default: null,
            type: [String, Number, Object, null] as PropType<string | number | Object | null>,
        },
        v: {
            type: Object,

        },
        TextLabel: {
            type: String,
        },
        label: {
            type: String,
        },
        valueProp: {
            type: [String, Number],
        },
        trackby: {
            type: [String, Number],
        },
        placeholder: {
            type: String,
            default: "",
        },
        refs: {
            type: String,
            default: "",
        },
        isEmpty: {
            type: Boolean,
            default: false,
        },
        arrayOptions: {
            type: Array,
        }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        // 
        const { modelValue } = toRefs(props);
        const selectedValue = ref(modelValue.value)
        const handleSelect = (value) => {

            emit('update:modelValue', value);
        };
        const handleDeselect = (value) => {
            emit('update:modelValue', value);
        };
        watch(
            () => props.modelValue,
            (newValue) => {
                if (newValue !== selectedValue.value) {
                    selectedValue.value = newValue;
                }
            });

        return {
            props,
            selectedValue,
            handleSelect,
            handleDeselect
        };
    },
});
</script>